import React from "react";
import PropTypes from "prop-types";
import { Popup, Icon } from "semantic-ui-react";

const NotaCell = ({ nota }) => {
	if (!nota || nota.length <= 25) return <span>{nota}</span>;

	return (
		<Popup
			trigger={
				<span>
					{nota.substring(0, 25)}...
					<Icon name="cloud" size="small" style={{ marginLeft: 4, cursor: "pointer" }} />
				</span>
			}
			content={nota}
			position="top center"
			size="small"
			inverted
		/>
	);
};

NotaCell.propTypes = {
	nota: PropTypes.string,
};

NotaCell.defaultProps = {
	nota: "",
};

export default NotaCell;
